export const CLIENT_CONFIGURATION_REQUEST = 'CLIENT_CONFIGURATION_REQUEST';
export const CLIENT_CONFIGURATION_SUCCESS = 'CLIENT_CONFIGURATION_SUCCESS';
export const CLIENT_CONFIGURATION_ERROR = 'CLIENT_CONFIGURATION_ERROR';

export const getClientConfig = () => {
    return {
        type: 'CALL_API',
        types: [CLIENT_CONFIGURATION_REQUEST, CLIENT_CONFIGURATION_SUCCESS, CLIENT_CONFIGURATION_ERROR],
        path: `api/clientconfiguration`,
        method: 'get',
    };
}

export const setClientConfig = (formData) => {
    return {
        type: 'CALL_API',
        types: [CLIENT_CONFIGURATION_REQUEST, CLIENT_CONFIGURATION_SUCCESS, CLIENT_CONFIGURATION_ERROR],
        path: `api/clientconfiguration`,
        method: 'post',
        payload: formData,
    };
}


// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/configuration.js